<template>
  <div class="cart-float-window" :style="{ left, bottom }" @click.stop="goCart">
    <IconFont name="gouwuche1" color="#fff" size="26px" />
    <div v-if="num" class="num">
      {{ num | numFormat }}
    </div>
  </div>
</template>

<script>
import { cart } from '@/utils/cart/index'
export default {
  name: 'CartFloatWindow',
  filters: {
    numFormat(value) {
      return value <= 99 ? value : '99+'
    }
  },
  props: {
    left: {
      type: String,
      default: '30px'
    },
    bottom: {
      type: String,
      default: '50px'
    }
  },
  data() {
    return {
      num: 0
    }
  },
  created() {
    this.num = cart.selectedGoodsAmount
    this.cartListenerId = cart.onChange(() => {
      this.num = cart.selectedGoodsAmount
    })
  },
  beforeDestroy() {
    cart.removeChangeHandler(this.cartListenerId)
  },
  methods: {
    goCart() {
      this.$emit('beforeGoCart')
      this.$nativeRedirect(this.$nativeRoutes.pureCart, { spm: '' })
    }
  }
}
</script>

<style lang="scss" scoped>
.cart-float-window {
  position: fixed;
  z-index: $z-float-window;

  width: 54px;
  height: 54px;

  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 27px;

  @include flex-row-center;

  &::v-deep i {
    flex: none;
  }

  .num {
    box-sizing: border-box;

    position: absolute;
    top: -2px;
    left: 54%;

    min-width: 18px;
    height: 18px;
    padding: 2px 4px;

    background-color: $theme-sub;
    border-radius: 10px;

    font-size: 12px;
    text-align: center;
    color: white;
  }
}
</style>
